import React from "react";
import "./ShareLegendModal.css";

function ShareLegendModal({
  onClose,
  langString,
  onShare,
}) {
  return (
    <>
      <div className="share-legend-overlay" onClick={(e) => {
        if (e.target === e.currentTarget) {
          e.stopPropagation();
          onClose();
        }
      }} />
      <div className="share-legend-modal">
        <button
          className="share-legend-close"
          onClick={onClose}
          aria-label="Close"
        >
          ✕
        </button>
        <div className="share-legend-content">
          <div className="share-legend-intro">
            {langString === "nl" 
              ? "Wanneer je je score deelt, verschijnen onderstaande symbolen. Ze laten zien hoe je het spel hebt gespeeld."
              : "When you share your score, the symbols below appear. They show how you played the game."}
          </div>
          <div className="share-legend-items">
            <div className="share-legend-item">
              <span className="share-legend-emoji">🟥</span>
              <div className="share-legend-text">
                <div className="share-legend-label">
                  {langString === "nl" ? "Mis" : "Miss"}
                </div>
                <div className="share-legend-description">
                  {langString === "nl" 
                    ? "klik op een vakje zonder letter."
                    : "click on a square without a letter."}
                </div>
              </div>
            </div>
            <div className="share-legend-item">
              <span className="share-legend-emoji">🟦</span>
              <div className="share-legend-text">
                <div className="share-legend-label">
                  {langString === "nl" ? "Raak" : "Hit"}
                </div>
                <div className="share-legend-description">
                  {langString === "nl" 
                    ? "klik op een vakje met letter."
                    : "click on a square with a letter."}
                </div>
              </div>
            </div>
            <div className="share-legend-item">
              <span className="share-legend-emoji">✅</span>
              <div className="share-legend-text">
                <div className="share-legend-label">
                  {langString === "nl" ? "woord juist" : "word correct"}
                </div>
                <div className="share-legend-description">
                  {langString === "nl" 
                    ? "correct woord geraden."
                    : "correct word guessed."}
                </div>
              </div>
            </div>
            <div className="share-legend-item">
              <span className="share-legend-emoji">❌</span>
              <div className="share-legend-text">
                <div className="share-legend-label">
                  {langString === "nl" ? "Woord fout" : "Word wrong"}
                </div>
                <div className="share-legend-description">
                  {langString === "nl" 
                    ? "verkeerd woord geraden."
                    : "wrong word guessed."}
                </div>
              </div>
            </div>
            <div className="share-legend-item">
              <span className="share-legend-emoji">🟩</span>
              <div className="share-legend-text">
                <div className="share-legend-label">
                  {langString === "nl" ? "Woord compleet" : "Word complete"}
                </div>
                <div className="share-legend-description">
                  {langString === "nl" 
                    ? "klik op laatste resterende letter van woord."
                    : "click on last remaining letter of word."}
                </div>
              </div>
            </div>
          </div>
          {onShare && (
            <div className="share-legend-share-button-container">
              <button
                type="button"
                onClick={() => {
                  onShare();
                  onClose();
                }}
                className="share-legend-share-button"
              >
                {langString === "nl" ? "Deel" : "Share"}
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ShareLegendModal;

